import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useConfirmPhoneChangeMutation = ({
	onSuccess,
	onError,
}: {
	onSuccess: Function;
	onError: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ code }: { code: string }) => {
			return usersService.confirmPhoneChange(code);
		},
		{
			onSuccess: () => {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				onError?.();
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useConfirmPhoneChangeMutation;
